import groq from 'groq';
import { queryNavGroup, SHOP_NAV } from 'lib/constants/navigation';
import {
  ASSET,
  BLOG_CARD,
  PRODUCT,
  PRODUCT_SLUG,
  RICH_TEXT,
} from 'lib/queries';
import type { SiteCategory } from 'types/common/SiteCategory';

export const filterPostsByCategory = (category = 'nutrition', count = 3) => {
  const conflictingCategory =
    category === 'skincare' ? 'nutrition' : 'skincare';

  return groq`
    *[ _type in['timeline_article','timeline_podcast'] && publishedAt < now() && "${category}" in categories && !("${conflictingCategory}" in categories)] | order(publishedAt desc) {
      ${BLOG_CARD}
    }[0..${count - 1}]
  `;
};

export const PRODUCTS_QUERY = groq`
  *[_type == "product" && !(_id in path('drafts.**')) && store.status != "archived" && store.isDeleted == false && store.status == "active"] {
    ${PRODUCT}
  }
`;

export const siteSettingsQuery = (category: SiteCategory) => {
  const isSkincare = category === 'skincare';

  const id = isSkincare ? 'skincare_settings' : 'settings';

  return groq`
    *[_type in['timeline_settings'] && _id == "${id}"][0] {
      shippingInfo[] {
        ${RICH_TEXT}
      },
      'plp': { ${queryNavGroup(SHOP_NAV)} },
      secondaryPlpMenu[] { ${queryNavGroup(SHOP_NAV)} },
      'featuredProducts': {
        'products': featuredProducts[].product -> {
          ${PRODUCT_SLUG} 
        }
      },
      scienceNav {
        navigationItems[] -> { _id },
        navigationCards[] {
          image { ${ASSET} },
          link -> { _id }
        }
      },
      footerHeading,
    }
  `;
};

export const reviewedProductsQuery = (category: SiteCategory) => {
  const isSkincare = category === 'skincare';
  const id = isSkincare ? 'skincare_reviews' : 'reviews';

  return groq`
    *[_type in ["timeline_reviews"] && _id == "${id}"][0].productCollection->products[].product->store.slug.current
  `;
};
